import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { MQ } from '@css/constants'

export const TestimonialsSectionWrapper = styled('div')(css`
  ${MQ.SMALL_SCREENS} {
    margin: 0 16px;
  }
`)
